import React from 'react';
import { Box, Inscription, Text } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { RenewalPlanOptionValues } from '../../RenewalSetup.types';
// import { useHandleExpressSetupSetUp } from '../../hooks';
import { RenewOptionCard } from '../../RenewOptionCard';
import { StepOption } from '../../stores/useRenewalSetup.store';

const AVAIBLE_OPTIONS = [
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Renew <span style={{ backgroundColor: theme.colors.textHighlighter }}>without</span> making changes to
        your plan(s)
      </Inscription>
    ),
    value: RenewalPlanOptionValues.ACTIVE,
  },
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Renew, but <span style={{ backgroundColor: theme.colors.textHighlighter }}>describe</span> changes to
        your plan(s)
      </Inscription>
    ),
    value: RenewalPlanOptionValues.REQUESTED,
  },
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Do not renew your plan(s)
      </Inscription>
    ),
    value: RenewalPlanOptionValues.CANCELED,
  },
];

interface Props {
  plansRenewSelectedOption?: StepOption;
  onOptionChange: (option: StepOption) => void;
}

const PlanYearsPlansForm: React.FC<Props> = ({ plansRenewSelectedOption, onOptionChange }) => {
  return (
    <Box
      background="module"
      pad="l"
      round="container1Round"
      gap="s"
      data-testid="renew-plan-year-plans-form-wrapper"
    >
      <Text color="textBody">Chose options:</Text>
      {AVAIBLE_OPTIONS.map((option) => {
        return (
          <RenewOptionCard
            key={option.value}
            title={option.label}
            optionValue={option.value}
            onClick={onOptionChange}
            isChecked={plansRenewSelectedOption === option.value}
          />
        );
      })}
    </Box>
  );
};

export default PlanYearsPlansForm;
